import React from 'react';
import { RadioButtonGroup } from '@framework-controls/core';
import css from './MobilePreviousList.module.scss';
import { IconDashMenu } from 'src/content/icons';
import { IndexMapInterface } from '../../WriteYourOwn';

interface IProps {
    // The radio button options for the current group
    radioItems: JSX.Element[];
    // Toggles display of the radio group
    toggleDisplay: (index: number) => void;
    index: number;
    option: string;
    // Handles changing a previously selected option
    selectPrevButtonHandler: (id: string, value: string) => void;
    indexMapItem: IndexMapInterface;
}

const MobilePreviousList = (props: IProps) => {
    if (props.indexMapItem.hidden) {
        return (
            <div className={css.previousList} key={props.index}>
                <p className={css.previousListOption + ' ' + css.bold}>{props.option}</p>
                <IconDashMenu onClick={() => props.toggleDisplay(props.index)}/>
            </div>
        );
    } else {
        return (
            <React.Fragment key={props.index}>
                <div className={css.previousListActive}>
                    <p className={css.previousListOption}>{props.option}</p>
                    <IconDashMenu onClick={() => props.toggleDisplay(props.index)}/>
                </div>
                <div className={css.previousGroup}>
                    <RadioButtonGroup
                        value={props.indexMapItem.index} id={props.index.toString()}
                        onChange={(id, value) => props.selectPrevButtonHandler(id, value)}>
                        {props.radioItems}
                    </RadioButtonGroup>
                </div>
            </React.Fragment>
        );
    }
};

export default MobilePreviousList;